"use strict";
/* PLAIN OBJECT IS EMPTY */
Object.defineProperty(exports, "__esModule", { value: true });
function isEmpty(x) {
    for (var key in x)
        return false;
    return true;
}
/* EXPORT */
exports.default = isEmpty;
